import React from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Banner from "../../components/Banner/Banner";
import Lightbox from "../../components/Lightbox/Lightbox";
import {
  MainContainer,
  Description,
  IntroContainer,
  SecurityImg,
  HappyCustomers,
  GrowthWrapper,
  ServiceContainer,
  Industries,
  Icon,
  IconWrapper,
  ArrowButton,
  BenefitsSection,
  BenefitCard,
  BenefitIcon,
  BenefitTitle,
  BenefitDescription,
  HowItWorksSection,
  StepContainer,
  StepNumber,
  StepContent,
  StepTitle,
  StepDescription,
  CTASection,
  SolarCalculator,
  CalculatorInput,
  SavingsDisplay,
  PortfolioSection,
  PortfolioGrid,
  PortfolioItem,
  PortfolioImage,
  PortfolioOverlay,
  PortfolioTitle,
  PortfolioLocation,
  ViewAllLink,
} from "./landingPage.style";
import Heading from "../../components/Header/Heading";
import SectionHeading from "../../components/SectionHeading/SectionHeading";
import IconCard from "../../components/IconCard/IconCard";
import Button from "../../components/Button/Button";
import cctv from "../../assets/cctv.png";
import doorlock from "../../assets/smart-lock.png";
import electricfence from "../../assets/electric-fence.png";
import telephone from "../../assets/intercom.png";
import solarsystem from "../../assets/solar-system.png";
import electricwiring from "../../assets/electric-wiring.png";
import telecom from "../../assets/telecom.png";
import transformer from "../../assets/transformer.png";
import shield from "../../assets/hero-graph.svg";
import business from "../../assets/business.svg";
import church from "../../assets/church.svg";
import education from "../../assets/education.svg";
import health from "../../assets/health.svg";
import retail from "../../assets/retail.svg";
import government from "../../assets/government.svg";
import prevarrow from "../../assets/prev-arrow.svg";
import nextarrow from "../../assets/next-arrow.svg";
import { colors } from "../../styles/colors";
import "./LandingPage.css";
import Accordion from "../../components/Accordion/Accordion";

// Portfolio images
import solarWork1 from "../../assets/solar-installation.jpeg";
import inverterWork1 from "../../assets/inverter-installation.jpeg";
import inverterWork2 from "../../assets/inverter-installation-02.jpeg";

export default function LandingPage() {
  const navigate = useNavigate();
  const [monthlyBill, setMonthlyBill] = React.useState(50000);
  const [lightboxOpen, setLightboxOpen] = React.useState(false);
  const [lightboxIndex, setLightboxIndex] = React.useState(0);
  const estimatedSavings = Math.round(monthlyBill * 0.8 * 12);

  const portfolioImages = [
    { src: solarWork1, title: "Solar Panel Installation", location: "Ibadan", description: "Complete solar panel system installation for residential property" },
    { src: inverterWork1, title: "Inverter Installation", location: "Ibadan", description: "Professional inverter setup with battery backup" },
    { src: inverterWork2, title: "Battery Storage Setup", location: "Ibadan", description: "Advanced battery storage system configuration" },
  ];

  const openLightbox = (index) => {
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  const navigateToProjects = () => {
    navigate("/projects");
  };

  React.useEffect(() => {
    document.title = "TrixieGroup & Association — Security & Solar Solutions";
  }, []);

  const services = [
    {
      icon: solarsystem,
      title: "Solar Panel Installation",
      description:
        "Premium solar panel systems designed and installed for maximum energy generation. Custom solutions for residential and commercial properties.",
    },
    {
      icon: transformer,
      title: "Battery Storage",
      description:
        "Store excess solar energy with advanced battery systems. Keep your lights on during outages and maximize your energy independence.",
    },
    {
      icon: telecom,
      title: "System Maintenance",
      description:
        "Comprehensive solar system monitoring and maintenance services. Regular inspections, cleaning, and performance optimization.",
    },
    {
      icon: electricwiring,
      title: "Energy Audit",
      description:
        "Professional energy assessments to identify savings opportunities. Get detailed reports and recommendations for your property.",
    },
    {
      icon: cctv,
      title: "Video Security",
      description:
        "Enjoy total peace of mind with a customized video security solution that fully protects your employees and physical property.",
    },
    {
      icon: doorlock,
      title: "Access Control",
      description:
        "Automated perimeter security ensures safety for your business and employees, utilizing keycard that track who comes and goes, to prevent unauthorized entry.",
    },
    {
      icon: electricfence,
      title: "Electric Fence",
      description:
        "Protect your staff, assets, and property with a custom electric fence that shocks and sounds an alarm on intrusion, ensuring strong perimeter security.",
    },
    {
      icon: telephone,
      title: "Intercom Systems",
      description:
        "Boost security with advanced video intercom systems that screen visitors and enable two-way communication across your home or business.",
    },
  ];

  const accordionData = [
    {
      title: "How much can I save with solar panels?",
      content: `Most of our customers save between 60-80% on their monthly electricity bills after installing solar panels. The exact savings depend on your energy consumption, roof orientation, and system size. During our free consultation, we’ll analyze your past 12 months of electricity bills and design a system that maximizes your savings. Many customers see a return on investment within 4-6 years.`,
    },
    {
      title: "How long does installation take?",
      content: `A typical residential solar installation takes 1-3 days, depending on system size and roof complexity. Commercial installations may take longer. Before installation day, we handle all permits and paperwork (usually 2-4 weeks). Our team works efficiently to minimize disruption to your daily routine. We’ll provide a detailed timeline during your consultation.`,
    },
    {
      title: "What financing options are available?",
      content: `We offer multiple financing options to make solar accessible: upfront purchase (best long-term savings), solar loans with competitive interest rates, and lease options. We can help you explore available government incentives and tax benefits that may reduce your total cost by 30% or more. Our team will walk you through each option to find what works best for your budget.`,
    },
    {
      title: "Do solar panels work during power outages?",
      content:
        "Standard grid-tied solar systems shut down during outages for safety. However, with our battery storage solutions, you can keep your essential appliances running during blackouts. Battery systems store excess solar energy for use when the sun isn’t shining or during power outages. Ask us about adding battery backup to your system.",
    },
    {
      title: "How long do solar panels last?",
      content:
        "Solar panels typically last 25-30 years with minimal degradation in performance. We provide 25-year warranties on panels and 10-year warranties on inverters and installation workmanship. Our maintenance packages ensure your system continues performing optimally throughout its lifetime. Most systems still produce 80-85% of their original capacity after 25 years.",
    },
    {
      title: "Will solar panels damage my roof?",
      content:
        "When installed correctly by certified professionals like our team, solar panels actually protect the covered portion of your roof. We use industry-best mounting systems that don’t compromise roof integrity. Our installations are fully insured and come with workmanship warranties. We also conduct thorough roof assessments before installation to ensure your roof is in good condition.",
    },
  ];

  const industries = [
    {
      icon: business,
      title: "Business Security",
      description:
        "From SMBs to large corporations, we design, install and service fully integrated business security solutions that protect your employees, assets and property from theft, vandalism, and unauthorized access.",
    },
    {
      icon: church,
      title: "Church Security",
      description:
        "We provide comprehensive video security and access control solutions for places of worship, to help protect congregants, clergy and staff members.",
    },
    {
      icon: education,
      title: "Education Security",
      description:
        "We provide comprehensive video security and access control solutions for schools, colleges and universities, to help protect students, staff and faculty members.",
    },
    {
      icon: health,
      title: "Health Security",
      description:
        "We provide comprehensive video security and access control solutions for health care facilities, to help protect patients, staff and visitors.",
    },
    {
      icon: retail,
      title: "Retail Security",
      description:
        "We provide comprehensive video security and access control solutions for retail and consumer shopping centres, to help protect customers, staff and visitors.",
    },
    {
      icon: government,
      title: "Government Security",
      description:
        "We provide comprehensive video security and access control solutions for government buildings, to help protect staff and visitors.",
    },
  ];

  const [customerCount, setCustomerCount] = React.useState(0);
  const [hasStarted, setHasStarted] = React.useState(false);
  const [isSliderInitialized, setIsSliderInitialized] = React.useState(false);
  const happyRef = React.useRef(null);

  React.useEffect(() => {
    const node = happyRef.current;
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasStarted) {
          setHasStarted(true);
        }
      },
      { threshold: 0.5 },
    );
    if (node) {
      observer.observe(node);
    }
    return () => {
      if (node) observer.unobserve(node);
    };
  }, [hasStarted]);

  React.useEffect(() => {
    if (!hasStarted) return;
    let count = 0;
    setCustomerCount(0);
    const interval = setInterval(() => {
      count += 8;
      if (count >= 400) {
        setCustomerCount(400);
        clearInterval(interval);
      } else {
        setCustomerCount(count);
      }
    }, 20);
    return () => clearInterval(interval);
  }, [hasStarted]);

  // Slider Buttons
  const NextArrow = ({ onClick }) => (
    <ArrowButton right onClick={onClick}>
      <img src={nextarrow} alt="Next" />
    </ArrowButton>
  );

  const PrevArrow = ({ onClick }) => (
    <ArrowButton left onClick={onClick}>
      <img src={prevarrow} alt="Previous" />
    </ArrowButton>
  );

  return (
    <div>
      <Banner />
      <MainContainer>
        <div className="background mt-64 container">
          <div className="d-flex flex-column justify-content-center align-items-center flex-md-row">
            <div data-aos="fade-right">
              <HappyCustomers ref={happyRef}>{customerCount}+</HappyCustomers>
              <Heading color={colors.dark}>
                Solar Installations Completed.
              </Heading>
            </div>

            <GrowthWrapper data-aos="fade-left">
              <SecurityImg src={shield} />
            </GrowthWrapper>
          </div>
        </div>

        <IntroContainer>
          <div className="container d-flex mt-64 mb-41 flex-column justify-content-start align-items-start">
            <SectionHeading data-aos="fade-up" noMargin>
              ABOUT US
            </SectionHeading>
            <Heading data-aos="fade-up">
              Security & Solar{" "}
              <span className="highlight">Solutions.</span>
            </Heading>
          </div>

          <div className="container bg-blue">
            <Description data-aos="fade-up" color={colors.light}>
              TrixieGroup & Association is a leading security technology company
              using advanced solutions to solve daily security challenges. We
              specialize in CCTV installations, access control systems, and
              perimeter security for homes and businesses.
            </Description>
            <Description data-aos="fade-up" color={colors.light}>
              In addition to security services, we provide professional Solar
              Inverter sales and installation. We help homes and businesses
              transition to clean, affordable solar power, reducing energy costs
              and ensuring reliable power supply.
            </Description>
            <Description data-aos="fade-up" color={colors.light}>
              With offices in Ibadan, our team of certified engineers delivers
              quality installations and ongoing support. From consultation to
              installation, we're committed to your safety and energy independence.
            </Description>
          </div>
        </IntroContainer>

        <BenefitsSection>
          <div
            data-aos="fade-up"
            className="container d-flex mt-64 mb-41 flex-column justify-content-center align-items-start"
          >
            <SectionHeading>WHY GO SOLAR</SectionHeading>
            <Heading>
              Benefits that <span className="highlight">matter.</span>
            </Heading>
          </div>

          <div className="container">
            <div className="row">
              {[
                {
                  icon: "💰",
                  title: "Save Money",
                  description: "Reduce your electricity bills by up to 80% and protect yourself from rising energy costs."
                },
                {
                  icon: "⚡",
                  title: "Energy Independence",
                  description: "Generate your own power and reduce reliance on the grid. Never worry about blackouts again."
                },
                {
                  icon: "🌱",
                  title: "Eco-Friendly",
                  description: "Reduce your carbon footprint and contribute to a cleaner environment for future generations."
                },
                {
                  icon: "🏠",
                  title: "Increase Value",
                  description: "Solar panels increase property value and make your home more attractive to buyers."
                }
              ].map((benefit, index) => (
                <div
                  key={index}
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                  className="col-12 col-md-6 col-lg-3 mb-4"
                >
                  <BenefitCard>
                    <BenefitIcon>{benefit.icon}</BenefitIcon>
                    <BenefitTitle>{benefit.title}</BenefitTitle>
                    <BenefitDescription>{benefit.description}</BenefitDescription>
                  </BenefitCard>
                </div>
              ))}
            </div>
          </div>
        </BenefitsSection>

        <HowItWorksSection>
          <div
            data-aos="fade-up"
            className="container d-flex mt-64 mb-41 flex-column justify-content-center align-items-center"
          >
            <SectionHeading>HOW IT WORKS</SectionHeading>
            <Heading style={{ textAlign: "center" }}>
              Your path to <span className="highlight">solar energy.</span>
            </Heading>
          </div>

          <div className="container">
            <div className="row justify-content-center">
              {[
                {
                  step: "01",
                  title: "Free Consultation",
                  description: "We assess your energy needs, roof condition, and design a custom solar system for your property."
                },
                {
                  step: "02",
                  title: "Custom Design",
                  description: "Our engineers create detailed plans optimized for maximum energy generation and aesthetics."
                },
                {
                  step: "03",
                  title: "Installation",
                  description: "Our certified installers complete the setup in 1-3 days with minimal disruption to your routine."
                },
                {
                  step: "04",
                  title: "Start Saving",
                  description: "Once connected, your system starts generating clean energy immediately. Track savings via our app."
                }
              ].map((item, index) => (
                <div
                  key={index}
                  data-aos="fade-up"
                  data-aos-delay={index * 150}
                  className="col-12 col-md-6 col-lg-3 mb-4"
                >
                  <StepContainer>
                    <StepNumber>{item.step}</StepNumber>
                    <StepContent>
                      <StepTitle>{item.title}</StepTitle>
                      <StepDescription>{item.description}</StepDescription>
                    </StepContent>
                  </StepContainer>
                </div>
              ))}
            </div>
          </div>
        </HowItWorksSection>

        <ServiceContainer>
          <div
            data-aos="fade-up"
            className="container-fluid d-flex mt-64 mb-41 flex-column justify-content-center align-items-end"
          >
            <SectionHeading>OUR SERVICES</SectionHeading>
            <Heading>
              Expert <span className="highlight">solutions.</span>
            </Heading>
          </div>

          <div style={{
            position: "relative",
            opacity: isSliderInitialized ? 1 : 0,
            transition: "opacity 0.4s ease",
            minHeight: isSliderInitialized ? "auto" : "300px",
          }}>
            <Slider
              onInit={() => setIsSliderInitialized(true)}
              dots={true}
              infinite={true}
              speed={500}
              autoplay={true}
              autoplaySpeed={3000}
              slidesToShow={window.innerWidth < 500 ? 1 : window.innerWidth < 1200 ? 2 : 3}
              slidesToScroll={1}
              centerMode={window.innerWidth >= 768}
              centerPadding={window.innerWidth < 768 ? "0px" : window.innerWidth < 1200 ? "30px" : "50px"}
              nextArrow={<NextArrow />}
              prevArrow={<PrevArrow />}
              responsive={[
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: 2,
                    centerMode: true,
                    centerPadding: "30px",
                  },
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                    centerMode: false,
                    centerPadding: "0px",
                  },
                },
                {
                  breakpoint: 500,
                  settings: {
                    slidesToShow: 1,
                    centerMode: false,
                    centerPadding: "0px",
                  },
                },
              ]}
            >
              {services.map((service) => (
                <div key={service.title} className="p-3">
                  <IconCard
                    icon={service.icon}
                    title={service.title}
                    description={service.description}
                  />
                </div>
              ))}
            </Slider>
          </div>
        </ServiceContainer>

        <CTASection>
          <div className="container" data-aos="fade-up">
            <SolarCalculator>
              <div className="calculator-header">
                <SectionHeading>SOLAR SAVINGS CALCULATOR</SectionHeading>
                <Heading>
                  See how much you could{" "}
                  <span className="highlight">save.</span>
                </Heading>
              </div>

              <div className="calculator-body">
                <div className="input-section">
                  <label>Your Monthly Electricity Bill (₦)</label>
                  <CalculatorInput
                    type="range"
                    min="10000"
                    max="500000"
                    step="5000"
                    value={monthlyBill}
                    onChange={(e) => setMonthlyBill(Number(e.target.value))}
                  />
                  <div className="bill-display">
                    ₦{monthlyBill.toLocaleString()}
                  </div>
                </div>

                <SavingsDisplay>
                  <div className="savings-item">
                    <span className="savings-label">Estimated Annual Savings</span>
                    <span className="savings-amount">₦{estimatedSavings.toLocaleString()}</span>
                  </div>
                  <Button
                    onClick={() => navigate("/contact")}
                    label="GET DETAILED QUOTE"
                    format="contained"
                    size="large"
                  />
                </SavingsDisplay>
              </div>
            </SolarCalculator>
          </div>
        </CTASection>

        <PortfolioSection>
          <div
            data-aos="fade-up"
            className="container d-flex mt-64 mb-41 flex-column justify-content-center align-items-center"
          >
            <SectionHeading>OUR WORK</SectionHeading>
            <Heading>
              Recent <span className="highlight">installations.</span>
            </Heading>
            <ViewAllLink onClick={navigateToProjects} data-aos="fade-up" data-aos-delay="200">
              View All Projects →
            </ViewAllLink>
          </div>

          <div className="container">
            <PortfolioGrid>
              {portfolioImages.map((item, index) => (
                <PortfolioItem
                  key={index}
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                  onClick={() => openLightbox(index)}
                >
                  <PortfolioImage src={item.src} alt={item.title} />
                  <PortfolioOverlay className="portfolio-overlay">
                    <PortfolioTitle>{item.title}</PortfolioTitle>
                    <PortfolioLocation>📍 {item.location}</PortfolioLocation>
                    <span style={{ color: '#fff', fontSize: '12px', marginTop: '8px', opacity: 0.8 }}>Click to view</span>
                  </PortfolioOverlay>
                </PortfolioItem>
              ))}
            </PortfolioGrid>
          </div>

          <Lightbox
            isOpen={lightboxOpen}
            onClose={closeLightbox}
            items={portfolioImages}
            currentIndex={lightboxIndex}
            onNavigate={setLightboxIndex}
          />
        </PortfolioSection>

        <div className="container">
          <Industries>
            <div
              data-aos="fade-up"
              className="container d-flex mt-64 mb-41 flex-column justify-content-center align-items-start"
            >
              <SectionHeading>INDUSTRIES SERVED</SectionHeading>

              <Heading>
                Who we <span className="highlight">serve.</span>{" "}
              </Heading>
            </div>
            <div className="row">
              {industries.map((industry) => {
                return (
                  <div
                    data-aos="fade-up"
                    key={industry.title}
                    className="col-12 col-md-6 col-lg-4 mb-3 d-flex justify-content-center"
                  >
                    <div className="background d-flex flex-column">
                      <section className="d-flex">
                        <IconWrapper>
                          <Icon src={industry.icon} alt={industry.title} />
                        </IconWrapper>
                        <Heading color={colors.dark} as="h2">
                          {industry.title}
                        </Heading>
                      </section>
                      <section>
                        <Description>{industry.description}</Description>
                      </section>
                    </div>
                  </div>
                );
              })}
            </div>
          </Industries>
        </div>

        <div
          data-aos="fade-up"
          className="container d-flex mt-64 mb-41 flex-column justify-content-center align-items-center"
        >
          <SectionHeading>FAQ</SectionHeading>
          <Heading>
            Frequently asked <span className="highlight">questions.</span>
          </Heading>
        </div>

        <div className="container">
          {accordionData.map((accordion) => (
            <Accordion
              key={accordion.title}
              title={accordion.title}
              content={accordion.content}
            />
          ))}
        </div>

        {/* CTA Section */}
        <div className="container" data-aos="fade-up">
          <div className="cta-section" style={{
            background: `linear-gradient(135deg, ${colors.secondary} 0%, ${colors.secondaryLight} 100%)`,
          }}>
            <h2 className="cta-title">Ready to Switch to Solar?</h2>
            <p className="cta-description">
              Get a free consultation and custom quote for your solar installation.
              Start saving on energy costs from day one.
            </p>
            <Button
              onClick={() => navigate("/contact")}
              label="GET FREE QUOTE"
              format="outlined"
              size="large"
            />
          </div>
        </div>
      </MainContainer>
    </div>
  );
}
